import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Storage() {
  return (
    <ScaffoldPage
      title="Storage Tiers"
      description="Manage hot, warm, and cold storage allocation for your data."
      breadcrumbs={buildBreadcrumbs('/settings/governance/storage')}
      plannedFeatures={[
        'Hot/warm/cold storage tier configuration',
        'Automatic data migration between tiers',
        'Storage cost optimization recommendations',
        'Data access speed vs. cost tradeoff controls',
      ]}
      relatedPages={[
        { label: 'Retention Policies', href: '/settings/governance/retention' },
        { label: 'Governance Dashboard', href: '/settings/governance/dashboard' },
      ]}
    />
  )
}
